import './ErrorPage.scss';
import { ReactComponent as Warning } from 'assets/warning.svg';

const ErrorPage = () =>{
  return (
      <div>
        <div className="submission-error-page">
          <div className=" logo-size"><Warning/></div>
          <div className="error-title">We are having technical issues loading your page.</div>
          <div className="error-content">Please <a className="error-link"
                                                   rel="noreferrer noopener"
                                                   href="https://www.troweprice.com/personal-investing/help/contact-us.html">call us</a> to speak with a representative or try again later.</div>
        </div>
      </div>
  );
}

export default ErrorPage;